var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.closePanel),expression:"closePanel"}],staticClass:"by-single-select"},[_c('div',{class:{
      'by-select-input': true,
      'by-select-input-border': _vm.isBorder,
      'by-select-input-border__active': _vm.isBorder && _vm.panelShow,
    },on:{"click":function($event){_vm.panelShow = !_vm.panelShow}}},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.placeholder))]),_c('i',{class:{
        'el-icon-arrow-down': true,
        'icon-rotate-open': _vm.panelShow,
        'icon-rotate-close': !_vm.panelShow,
        'span-active': _vm.text && !_vm.isBorder,
      }})]),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.panelShow),expression:"panelShow"}],class:{
        'by-panel': true,
        'by-panel-border': _vm.isBorder,
        'by-panel-width': _vm.isMinWidth,
      },on:{"mouseenter":function($event){_vm.panelOpen = true},"mouseleave":function($event){_vm.panelOpen = false}}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }